import { Button } from '../../../../components/ui/button';

const ImageDeleteWarning = ({
  setVisibleModel,
}: {
  setVisibleModel: () => void;
}) => {
  return (
    <div className="z-50 bg-black/50">
      <div className="fixed left-1/2 top-1/2 h-auto w-[400px] lg:w-[28vw] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background p-[25px] text-text-primary">
        <div className="text-xl text-primary font-bold">Warning</div>
        <div className="mb-5 mt-2.5 text-[15px] leading-normal text-mauve11">
          Please do not remove the images from the text, as they are
          AI-generated.
        </div>
        <div className="mt-[25px] gap-4 flex justify-end">
          <div onClick={setVisibleModel}>
            <Button
              variant={'customSecondary'}
              className="bg-secondary text-text-primary"
              size={'sm'}
            >
              Close
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageDeleteWarning;
